import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Router, ActivatedRoute } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { DistributorsService, IDistributorGPSPatchRequest } from "./distributors.service";
import { AlertService, BaseComponent, BaseComponentMode } from "@impacgroup/angular-baselib";
import { DistributorDetails } from "src/app/api-models/Distributor";
import { setOptions, importLibrary } from "@googlemaps/js-api-loader";

@Component({
    selector: "app-distributordetails",
    templateUrl: "./distributordetails.component.html",
    styleUrls: ["distributordetails.component.scss"],
    standalone: false
})
export class DistributorDetailsComponent extends BaseComponent implements OnInit {
    private distributorId: string = null;
    public distributor: DistributorDetails = null;
    private mapOptions = {
        center: {
            lat: 51.165691,
            lng: 10.451526
        },
        zoom: 6,
        mapId: "DISTRIBUTOR_LOCATION",
        libraries: ["maps", "marker"]
    };
    private mapApiKey: string = null;

    public displayedGpsCoords: { lat?: number; lng?: number } = { lat: undefined, lng: undefined };

    constructor(private route: ActivatedRoute, private distributorsService: DistributorsService, private router: Router, private alertService: AlertService, private translateService: TranslateService, private modalService: BsModalService) {
        super();

        this.subscriptions.push(
            this.route.params.subscribe((params) => {
                this.distributorId = params.id;
                if (this.distributorId) {
                    this.initEditMode();
                } else {
                    this.back();
                }
            })
        );
    }

    ngOnInit(): void {}

    initEditMode() {
        this.MODE = BaseComponentMode.EDIT;

        this.loadMapsApiKey();
    }

    refreshDistributor() {
        this.subscriptions.push(
            this.distributorsService.distributorDetails(this.distributorId).subscribe(
                (result) => {
                    this.distributor = result;
                    if (this.distributor.gpsLocation && this.distributor.gpsLocation.coordinates && this.distributor.gpsLocation.coordinates.length === 2) {
                        this.initMap({ lng: this.distributor.gpsLocation.coordinates[0], lat: this.distributor.gpsLocation.coordinates[1] });
                    }
                },
                (err) => {
                    this.router.navigate(["../"], { relativeTo: this.route });
                }
            )
        );
    }

    loadMapsApiKey() {
        this.subscriptions.push(
            this.distributorsService.getGoogleMapsKey().subscribe(
                (result) => {
                    this.mapApiKey = result.key;
                    this.initMap();
                    this.refreshDistributor();
                },
                (err) => {
                    this.router.navigate(["../"], { relativeTo: this.route });
                }
            )
        );
    }

    async initMap(center?: { lat: number; lng: number }) {
        if (!this.mapApiKey) {
            return;
        }

        setOptions({ key: this.mapApiKey, v: "weekly" });

        if (center) {
            this.mapOptions.center = center;
            this.mapOptions.zoom = 14;
            this.displayedGpsCoords = center;
        }

        const { Map } = await importLibrary("maps");
        const { AdvancedMarkerElement } = (await importLibrary("marker"));

        const map = new Map(document.getElementById("map"), this.mapOptions);
        const marker = new AdvancedMarkerElement({
            map: map,
            position: center,
            title: "Händler"
        });
    }

    onCoordsChanged(coords: { lat?: number; lng?: number }) {
        this.initMap({ lat: coords.lat ? coords.lat : this.displayedGpsCoords.lat, lng: coords.lng ? coords.lng : this.displayedGpsCoords.lng });
    }

    back() {
        this.router.navigate(["../"], { relativeTo: this.route });
    }

    save() {
        const patchObj: IDistributorGPSPatchRequest = {
            _id: this.distributorId,
            version: this.distributor.version,
            gpsLocation: {
                coordinates: [this.displayedGpsCoords.lng, this.displayedGpsCoords.lat]
            }
        };

        this.subscriptions.push(
            this.distributorsService.updateDistributorCoords(patchObj).subscribe(
                (result) => {
                    this.distributor = result;
                    if (this.distributor.gpsLocation && this.distributor.gpsLocation.coordinates.length === 2) {
                        this.initMap({ lng: this.distributor.gpsLocation.coordinates[0], lat: this.distributor.gpsLocation.coordinates[1] });
                    }
                    this.alertService.addSuccess(this.translateService.instant("distributors.details.dialog.success"));
                },
                (err) => {
                    this.alertService.addCustomError(this.translateService.instant("distributors.details.dialog.failure"));
                }
            )
        );
    }

    isSaveDisabled(): boolean {
        if (!this.displayedGpsCoords.lng || !this.displayedGpsCoords.lat) {
            return true;
        }
        if (!this.distributor || !this.distributor.gpsLocation || !this.distributor.gpsLocation.coordinates || this.distributor.gpsLocation.coordinates.length !== 2) {
            return false;
        }
        return this.displayedGpsCoords.lat === this.distributor.gpsLocation.coordinates[1] && this.displayedGpsCoords.lng === this.distributor.gpsLocation.coordinates[0];
    }
}
